/**
 * Default copy for the public maintenance page when no custom message is stored.
 */
export const DEFAULT_MAINTENANCE_MESSAGE =
  'Our website is currently undergoing scheduled maintenance. We appreciate your patience and will be back soon!';

/** Custom message if set; otherwise the default maintenance page copy. */
export function resolveMaintenanceMessage(message?: string | null): string {
  const trimmed = message?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_MAINTENANCE_MESSAGE;
}
